import { Token } from '@lumino/coreutils';
/**
 * The default document provider token.
 */
export const IDocumentProviderFactory = new Token('@jupyterlab/docprovider:IDocumentProviderFactory');
//# sourceMappingURL=tokens.js.map